import React from 'react';
import { Breadcrumbs, BreadcrumbsItem } from 'fronton-react';
import { jc, patchUrlByLocale } from 'utils';
import { pdpSectionStyle } from 'common/components/page-section';
import { useSelector } from 'react-redux';
import { getBreadcrumbs } from 'features/page-model/selectors';
import { css } from 'linaria';

export type PdpBreadcrumpsProps = React.HTMLAttributes<HTMLElement>;

export const PdpBreadcrumps: React.FC<PdpBreadcrumpsProps> = ({ id, className }) => {
  const brgs = useSelector(getBreadcrumbs) || [];
  return (
    <section
      data-breadgrumbs=""
      id={id}
      data-qa={id}
      className={jc(pdpSectionStyle, breadcrumbsSection, className || '')}
    >
      <Breadcrumbs addSEOAttributes={false}>
        {brgs.map((brg) => (
          <BreadcrumbsItem key={brg.link} href={patchUrlByLocale(brg.link)}>
            {brg.label}
          </BreadcrumbsItem>
        ))}
      </Breadcrumbs>
    </section>
  );
};

const breadcrumbsSection = css`
  margin-top: var(--space-300);
`;
